"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var CfgPayoutEditor_1 = require("./component/CfgPayoutEditor");
var CfgPayoutList_1 = require("./component/CfgPayoutList");
var PCfgPayoutList = /** @class */ (function (_super) {
    __extends(PCfgPayoutList, _super);
    function PCfgPayoutList(props) {
        return _super.call(this, props) || this;
    }
    PCfgPayoutList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AC = this.props.appCurrencyData.Subscribe("*", function (id, data) {
            _this.setState({
                avail_currency: data.data
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            avail_currency: [],
            page_num: 1,
            page_size: this.props.state.getTablePageSize()
        }, function () {
            _this.props.appCurrencyData.LoadData();
        });
    };
    PCfgPayoutList.prototype.componentWillUnmount = function () {
        this.props.appCurrencyData.UnSubscribe(this.SID_AC);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PCfgPayoutList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PCfgPayoutList.prototype.onEditClick = function (id) {
        this.setState({ edit_mode: "EDIT", record: id });
    };
    PCfgPayoutList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    PCfgPayoutList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PCfgPayoutList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(CfgPayoutEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this), availCurrency: this.state.avail_currency }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(CfgPayoutEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackClick.bind(this), availCurrency: this.state.avail_currency }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(CfgPayoutList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PCfgPayoutList.prototype.render = function () {
        return this.getRenderObject();
    };
    PCfgPayoutList.getPageDescription = function (state) {
        return {
            icon: "credit-card",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_config_payouts + "-id",
            itemTitle: "Типы выплат",
            route: routes_1.routes.page_config_payouts,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PCfgPayoutList;
}(React.Component));
exports.default = PCfgPayoutList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_payout/ui/PCfgPayoutList.tsx
// module id = 2449
// module chunks = 0